import { render } from "./KnotArchive.vue?vue&type=template&id=79f7ae72&scoped=true"
import script from "./KnotArchive.vue?vue&type=script&lang=js"
export * from "./KnotArchive.vue?vue&type=script&lang=js"

import "./KnotArchive.vue?vue&type=style&index=0&id=79f7ae72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f7ae72"]])

export default __exports__